import { Component } from 'san';
import * as _ from 'lodash';

import projectService from 'src/services/project.service';
import { IProjectFilterItem } from 'src/models';

export default class CheckGroups extends Component {
    static computed = {
        checkedGroups() {
            const groups = this.data.get('groups');
            return _.filter(groups, { is_checked: true });
        }
    }

    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;
        defaultCheckedGroupIds: string[];  // (input)默认选中的group ids
        groups: IProjectFilterItem[];
    } {
        return {
            isShow: false,
            defaultCheckedGroupIds: [],
            groups: []
        };
    }

    inited() {
        this.watch('isShow', (isShow) => {
            if (isShow) {
                this.init();
            }
        });
    }

    init() {
        this.initGroups();
    }

    initGroups() {
        projectService.getProjectFilters().then(projectFilters => {
            const groups = projectFilters['group'].items;
            const defaultCheckedGroupIds = this.data.get('defaultCheckedGroupIds');
            _.forEach(groups, group => {
                group.is_checked = _.includes(defaultCheckedGroupIds, group.value);
            })
            const dataKey = 'groups';
            const oldGroups = this.data.get(dataKey);
            this.data.splice(dataKey, [0, oldGroups.length, ...groups]);
        });
    }


    submit() {
        const checkedGroups = this.data.get('checkedGroups');
        this.fire('checked-groups-change', checkedGroups);
        this.cancel();
    }

    cancel() {
        this.data.set('isShow', false);
    }
}